// extracted by mini-css-extract-plugin
export default {"list":"Search_list__F1RsU","item":"Search_item__ImXX+","button":"Search_button__Z+85s","searchLabel":"Search_searchLabel__Y0yuK","active":"Search_active__FZPjw"};